import { Alert, Paragraph, TextLink, useSnackbar } from 'ui-components';
import { SITE_URL } from '~/utils';

interface Props {
  lastUpdatedDate: string;
  platformFullAccess: boolean;
}

export const DisconnectedCard = ({
  lastUpdatedDate,
  platformFullAccess,
}: Props) => {
  const snackbar = useSnackbar();

  const handleCopy = async () => {
    try {
      const link = platformFullAccess
        ? `${SITE_URL}/platform-connections`
        : `${SITE_URL}/connection-dashboard`;
      await navigator.clipboard.writeText(link);
      snackbar.success({
        description: 'Link successfully copied',
        duration: 2000,
        isCloseable: true,
      });
    } catch (err) {
      snackbar.error({
        description: 'Failed to copy',
        duration: 2000,
        isCloseable: true,
      });
    }
  };

  return (
    <Alert background="primary.50" padding={4} borderRadius={8}>
      <Paragraph size="md">
        Heads up! These metrics were last updated on {lastUpdatedDate}. It seems
        the account is disconnected. Send the talent{' '}
        <TextLink onClick={handleCopy} isBold>
          this link
        </TextLink>{' '}
        to get the latest data.
      </Paragraph>
    </Alert>
  );
};
